// src/components/Admin/organizations/ToContactPane.tsx
import React, { useState } from 'react';
import { OrganizationItem } from '../../../api/adminOrganizationsService';
import OrgsTable       from './OrgsTable';
import CompanyInfo     from './CompanyInfo';
import EmployeeSelector from './EmployeeSelector';
import { sendOrganizationEmail } from '../../../api/adminOrganizationsService';

interface Props {
  items:  OrganizationItem[];
  reload: () => void;
}

const ToContactPane: React.FC<Props> = ({ items, reload }) => {
  const [selectedOrg, setSelectedOrg] = useState<OrganizationItem | null>(null);
  const [recipients,  setRecipients]  = useState<string[]>([]);
  const [sending, setSending] = useState(false);

  const canSend = !!selectedOrg && recipients.length > 0;

  const handleSendLead = async () => {
    if (!selectedOrg) return;
    setSending(true);
    try {
      await sendOrganizationEmail(selectedOrg.org.id, recipients, 'lead_contact');
      setRecipients([]);
      reload();
    } catch (e) {
      console.error(e);
      alert('Error al enviar email de contacto');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <OrgsTable
        items={items}
        selectedId={selectedOrg?.org.id ?? null}
        onSelect={(it) => { setSelectedOrg(it); setRecipients([]); }}
      />

      <div className="grid grid-rows-[auto_auto_1fr_auto] gap-4">
        <CompanyInfo item={selectedOrg} />
        <EmployeeSelector
          org={selectedOrg}
          selected={recipients}
          onChange={setRecipients}
        />

        {/* ── Botonera ── */}
        <div className="flex items-center gap-3">
          <button
            className="px-3 py-2 rounded bg-blue-600 text-white disabled:opacity-50"
            disabled={!canSend || sending}
            onClick={handleSendLead}
          >
            {sending ? 'Enviando…' : 'Enviar contacto'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ToContactPane;
